import './hero.less';

// trim-below
import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

const b = block('hero');

const HeroItem = ({index, title, summary, linkText, link, imagePath, imagePathMobile, theme, h1}) => (
	<div className={b('item', {theme})}>
		<style dangerouslySetInnerHTML={{__html: `
			.hero__img_${index} {background-image: url(${imagePathMobile})}
			
			@media (min-width: 960px) {
				.hero__img_${index} {background-image: url(${imagePath})}
			}
		`}}/>
		<div className={b('img', `hero__img_${index}`)} />
		<div className={b('container')}>
			<div className={b('content')}>
				{
					h1 &&
					<h1 className={b('title')}>{title}</h1>
				}
				{
					!h1 &&
					<h2 className={b('title')}>{title}</h2>
				}
				<p className={b('summary')}>{summary}</p>
				{
					link &&
					<a className={b('link')} href={link}>
						{linkText}
						<svg className={b('icon')} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width="12" height="12">
							<path d="M12.7,11L4,19.4L6.7,22L18,11L6.7,0L4,2.6L12.7,11z" />
						</svg>
					</a>
				}
			</div>
		</div>
	</div>
);

HeroItem.propTypes = {
	title: PropTypes.string.isRequired,
	summary: PropTypes.string,
	link: PropTypes.string,
	linkText: PropTypes.string,
	imagePath: PropTypes.string.isRequired,
	imagePathMobile: PropTypes.string,
	theme: PropTypes.string,
	h1: PropTypes.bool,
	index: PropTypes.number
};

export default HeroItem;



// WEBPACK FOOTER //
// ./src/components/hero/hero-item.jsx